var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDots(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 144,
    height: 176,
    viewBox: "0 0 144 176",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 144,
    height: 176,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Repeat_Grid_9",
    "data-name": "Repeat Grid 9",
    opacity: 0.43,
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1743 -17104)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_301",
    "data-name": "Ellipse 301",
    cx: 4.5,
    cy: 4.5,
    r: 4.5,
    transform: "translate(1743 17104)",
    fill: "#8296e8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_302",
    "data-name": "Ellipse 302",
    cx: 4.5,
    cy: 4.5,
    r: 4.5,
    transform: "translate(1759 17104)",
    fill: "#8296e8"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1709 -17104)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_301-2",
    "data-name": "Ellipse 301",
    cx: 4.5,
    cy: 4.5,
    r: 4.5,
    transform: "translate(1743 17104)",
    fill: "#8296e8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_302-2",
    "data-name": "Ellipse 302",
    cx: 4.5,
    cy: 4.5,
    r: 4.5,
    transform: "translate(1759 17104)",
    fill: "#8296e8"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1675 -17104)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_301-3",
    "data-name": "Ellipse 301",
    cx: 4.5,
    cy: 4.5,
    r: 4.5,
    transform: "translate(1743 17104)",
    fill: "#8296e8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_302-3",
    "data-name": "Ellipse 302",
    cx: 4.5,
    cy: 4.5,
    r: 4.5,
    transform: "translate(1759 17104)",
    fill: "#8296e8"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1641 -17104)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_301-4",
    "data-name": "Ellipse 301",
    cx: 4.5,
    cy: 4.5,
    r: 4.5,
    transform: "translate(1743 17104)",
    fill: "#8296e8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_302-4",
    "data-name": "Ellipse 302",
    cx: 4.5,
    cy: 4.5,
    r: 4.5,
    transform: "translate(1759 17104)",
    fill: "#8296e8"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1607 -17104)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_301-5",
    "data-name": "Ellipse 301",
    cx: 4.5,
    cy: 4.5,
    r: 4.5,
    transform: "translate(1743 17104)",
    fill: "#8296e8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_302-5",
    "data-name": "Ellipse 302",
    cx: 4.5,
    cy: 4.5,
    r: 4.5,
    transform: "translate(1759 17104)",
    fill: "#8296e8"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1743 -17089)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_301-6",
    "data-name": "Ellipse 301",
    cx: 4.5,
    cy: 4.5,
    r: 4.5,
    transform: "translate(1743 17104)",
    fill: "#8296e8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_302-6",
    "data-name": "Ellipse 302",
    cx: 4.5,
    cy: 4.5,
    r: 4.5,
    transform: "translate(1759 17104)",
    fill: "#8296e8"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1709 -17089)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_301-7",
    "data-name": "Ellipse 301",
    cx: 4.5,
    cy: 4.5,
    r: 4.5,
    transform: "translate(1743 17104)",
    fill: "#8296e8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_302-7",
    "data-name": "Ellipse 302",
    cx: 4.5,
    cy: 4.5,
    r: 4.5,
    transform: "translate(1759 17104)",
    fill: "#8296e8"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1675 -17089)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_301-8",
    "data-name": "Ellipse 301",
    cx: 4.5,
    cy: 4.5,
    r: 4.5,
    transform: "translate(1743 17104)",
    fill: "#8296e8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_302-8",
    "data-name": "Ellipse 302",
    cx: 4.5,
    cy: 4.5,
    r: 4.5,
    transform: "translate(1759 17104)",
    fill: "#8296e8"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1641 -17089)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_301-9",
    "data-name": "Ellipse 301",
    cx: 4.5,
    cy: 4.5,
    r: 4.5,
    transform: "translate(1743 17104)",
    fill: "#8296e8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_302-9",
    "data-name": "Ellipse 302",
    cx: 4.5,
    cy: 4.5,
    r: 4.5,
    transform: "translate(1759 17104)",
    fill: "#8296e8"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1607 -17089)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_301-10",
    "data-name": "Ellipse 301",
    cx: 4.5,
    cy: 4.5,
    r: 4.5,
    transform: "translate(1743 17104)",
    fill: "#8296e8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_302-10",
    "data-name": "Ellipse 302",
    cx: 4.5,
    cy: 4.5,
    r: 4.5,
    transform: "translate(1759 17104)",
    fill: "#8296e8"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1743 -17074)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_301-11",
    "data-name": "Ellipse 301",
    cx: 4.5,
    cy: 4.5,
    r: 4.5,
    transform: "translate(1743 17104)",
    fill: "#8296e8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_302-11",
    "data-name": "Ellipse 302",
    cx: 4.5,
    cy: 4.5,
    r: 4.5,
    transform: "translate(1759 17104)",
    fill: "#8296e8"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1709 -17074)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_301-12",
    "data-name": "Ellipse 301",
    cx: 4.5,
    cy: 4.5,
    r: 4.5,
    transform: "translate(1743 17104)",
    fill: "#8296e8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_302-12",
    "data-name": "Ellipse 302",
    cx: 4.5,
    cy: 4.5,
    r: 4.5,
    transform: "translate(1759 17104)",
    fill: "#8296e8"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1675 -17074)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_301-13",
    "data-name": "Ellipse 301",
    cx: 4.5,
    cy: 4.5,
    r: 4.5,
    transform: "translate(1743 17104)",
    fill: "#8296e8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_302-13",
    "data-name": "Ellipse 302",
    cx: 4.5,
    cy: 4.5,
    r: 4.5,
    transform: "translate(1759 17104)",
    fill: "#8296e8"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1641 -17074)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_301-14",
    "data-name": "Ellipse 301",
    cx: 4.5,
    cy: 4.5,
    r: 4.5,
    transform: "translate(1743 17104)",
    fill: "#8296e8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_302-14",
    "data-name": "Ellipse 302",
    cx: 4.5,
    cy: 4.5,
    r: 4.5,
    transform: "translate(1759 17104)",
    fill: "#8296e8"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1607 -17074)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_301-15",
    "data-name": "Ellipse 301",
    cx: 4.5,
    cy: 4.5,
    r: 4.5,
    transform: "translate(1743 17104)",
    fill: "#8296e8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_302-15",
    "data-name": "Ellipse 302",
    cx: 4.5,
    cy: 4.5,
    r: 4.5,
    transform: "translate(1759 17104)",
    fill: "#8296e8"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1743 -17059)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_301-16",
    "data-name": "Ellipse 301",
    cx: 4.5,
    cy: 4.5,
    r: 4.5,
    transform: "translate(1743 17104)",
    fill: "#8296e8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_302-16",
    "data-name": "Ellipse 302",
    cx: 4.5,
    cy: 4.5,
    r: 4.5,
    transform: "translate(1759 17104)",
    fill: "#8296e8"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1709 -17059)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_301-17",
    "data-name": "Ellipse 301",
    cx: 4.5,
    cy: 4.5,
    r: 4.5,
    transform: "translate(1743 17104)",
    fill: "#8296e8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_302-17",
    "data-name": "Ellipse 302",
    cx: 4.5,
    cy: 4.5,
    r: 4.5,
    transform: "translate(1759 17104)",
    fill: "#8296e8"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1675 -17059)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_301-18",
    "data-name": "Ellipse 301",
    cx: 4.5,
    cy: 4.5,
    r: 4.5,
    transform: "translate(1743 17104)",
    fill: "#8296e8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_302-18",
    "data-name": "Ellipse 302",
    cx: 4.5,
    cy: 4.5,
    r: 4.5,
    transform: "translate(1759 17104)",
    fill: "#8296e8"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1641 -17059)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_301-19",
    "data-name": "Ellipse 301",
    cx: 4.5,
    cy: 4.5,
    r: 4.5,
    transform: "translate(1743 17104)",
    fill: "#8296e8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_302-19",
    "data-name": "Ellipse 302",
    cx: 4.5,
    cy: 4.5,
    r: 4.5,
    transform: "translate(1759 17104)",
    fill: "#8296e8"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1607 -17059)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_301-20",
    "data-name": "Ellipse 301",
    cx: 4.5,
    cy: 4.5,
    r: 4.5,
    transform: "translate(1743 17104)",
    fill: "#8296e8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_302-20",
    "data-name": "Ellipse 302",
    cx: 4.5,
    cy: 4.5,
    r: 4.5,
    transform: "translate(1759 17104)",
    fill: "#8296e8"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1743 -17044)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_301-21",
    "data-name": "Ellipse 301",
    cx: 4.5,
    cy: 4.5,
    r: 4.5,
    transform: "translate(1743 17104)",
    fill: "#8296e8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_302-21",
    "data-name": "Ellipse 302",
    cx: 4.5,
    cy: 4.5,
    r: 4.5,
    transform: "translate(1759 17104)",
    fill: "#8296e8"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1709 -17044)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_301-22",
    "data-name": "Ellipse 301",
    cx: 4.5,
    cy: 4.5,
    r: 4.5,
    transform: "translate(1743 17104)",
    fill: "#8296e8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_302-22",
    "data-name": "Ellipse 302",
    cx: 4.5,
    cy: 4.5,
    r: 4.5,
    transform: "translate(1759 17104)",
    fill: "#8296e8"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1675 -17044)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_301-23",
    "data-name": "Ellipse 301",
    cx: 4.5,
    cy: 4.5,
    r: 4.5,
    transform: "translate(1743 17104)",
    fill: "#8296e8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_302-23",
    "data-name": "Ellipse 302",
    cx: 4.5,
    cy: 4.5,
    r: 4.5,
    transform: "translate(1759 17104)",
    fill: "#8296e8"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1641 -17044)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_301-24",
    "data-name": "Ellipse 301",
    cx: 4.5,
    cy: 4.5,
    r: 4.5,
    transform: "translate(1743 17104)",
    fill: "#8296e8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_302-24",
    "data-name": "Ellipse 302",
    cx: 4.5,
    cy: 4.5,
    r: 4.5,
    transform: "translate(1759 17104)",
    fill: "#8296e8"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1607 -17044)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_301-25",
    "data-name": "Ellipse 301",
    cx: 4.5,
    cy: 4.5,
    r: 4.5,
    transform: "translate(1743 17104)",
    fill: "#8296e8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_302-25",
    "data-name": "Ellipse 302",
    cx: 4.5,
    cy: 4.5,
    r: 4.5,
    transform: "translate(1759 17104)",
    fill: "#8296e8"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1743 -17029)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_301-26",
    "data-name": "Ellipse 301",
    cx: 4.5,
    cy: 4.5,
    r: 4.5,
    transform: "translate(1743 17104)",
    fill: "#8296e8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_302-26",
    "data-name": "Ellipse 302",
    cx: 4.5,
    cy: 4.5,
    r: 4.5,
    transform: "translate(1759 17104)",
    fill: "#8296e8"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1709 -17029)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_301-27",
    "data-name": "Ellipse 301",
    cx: 4.5,
    cy: 4.5,
    r: 4.5,
    transform: "translate(1743 17104)",
    fill: "#8296e8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_302-27",
    "data-name": "Ellipse 302",
    cx: 4.5,
    cy: 4.5,
    r: 4.5,
    transform: "translate(1759 17104)",
    fill: "#8296e8"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1675 -17029)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_301-28",
    "data-name": "Ellipse 301",
    cx: 4.5,
    cy: 4.5,
    r: 4.5,
    transform: "translate(1743 17104)",
    fill: "#8296e8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_302-28",
    "data-name": "Ellipse 302",
    cx: 4.5,
    cy: 4.5,
    r: 4.5,
    transform: "translate(1759 17104)",
    fill: "#8296e8"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1641 -17029)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_301-29",
    "data-name": "Ellipse 301",
    cx: 4.5,
    cy: 4.5,
    r: 4.5,
    transform: "translate(1743 17104)",
    fill: "#8296e8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_302-29",
    "data-name": "Ellipse 302",
    cx: 4.5,
    cy: 4.5,
    r: 4.5,
    transform: "translate(1759 17104)",
    fill: "#8296e8"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1607 -17029)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_301-30",
    "data-name": "Ellipse 301",
    cx: 4.5,
    cy: 4.5,
    r: 4.5,
    transform: "translate(1743 17104)",
    fill: "#8296e8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_302-30",
    "data-name": "Ellipse 302",
    cx: 4.5,
    cy: 4.5,
    r: 4.5,
    transform: "translate(1759 17104)",
    fill: "#8296e8"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1743 -17014)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_301-31",
    "data-name": "Ellipse 301",
    cx: 4.5,
    cy: 4.5,
    r: 4.5,
    transform: "translate(1743 17104)",
    fill: "#8296e8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_302-31",
    "data-name": "Ellipse 302",
    cx: 4.5,
    cy: 4.5,
    r: 4.5,
    transform: "translate(1759 17104)",
    fill: "#8296e8"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1709 -17014)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_301-32",
    "data-name": "Ellipse 301",
    cx: 4.5,
    cy: 4.5,
    r: 4.5,
    transform: "translate(1743 17104)",
    fill: "#8296e8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_302-32",
    "data-name": "Ellipse 302",
    cx: 4.5,
    cy: 4.5,
    r: 4.5,
    transform: "translate(1759 17104)",
    fill: "#8296e8"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1675 -17014)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_301-33",
    "data-name": "Ellipse 301",
    cx: 4.5,
    cy: 4.5,
    r: 4.5,
    transform: "translate(1743 17104)",
    fill: "#8296e8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_302-33",
    "data-name": "Ellipse 302",
    cx: 4.5,
    cy: 4.5,
    r: 4.5,
    transform: "translate(1759 17104)",
    fill: "#8296e8"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1641 -17014)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_301-34",
    "data-name": "Ellipse 301",
    cx: 4.5,
    cy: 4.5,
    r: 4.5,
    transform: "translate(1743 17104)",
    fill: "#8296e8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_302-34",
    "data-name": "Ellipse 302",
    cx: 4.5,
    cy: 4.5,
    r: 4.5,
    transform: "translate(1759 17104)",
    fill: "#8296e8"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1607 -17014)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_301-35",
    "data-name": "Ellipse 301",
    cx: 4.5,
    cy: 4.5,
    r: 4.5,
    transform: "translate(1743 17104)",
    fill: "#8296e8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_302-35",
    "data-name": "Ellipse 302",
    cx: 4.5,
    cy: 4.5,
    r: 4.5,
    transform: "translate(1759 17104)",
    fill: "#8296e8"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1743 -16999)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_301-36",
    "data-name": "Ellipse 301",
    cx: 4.5,
    cy: 4.5,
    r: 4.5,
    transform: "translate(1743 17104)",
    fill: "#8296e8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_302-36",
    "data-name": "Ellipse 302",
    cx: 4.5,
    cy: 4.5,
    r: 4.5,
    transform: "translate(1759 17104)",
    fill: "#8296e8"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1709 -16999)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_301-37",
    "data-name": "Ellipse 301",
    cx: 4.5,
    cy: 4.5,
    r: 4.5,
    transform: "translate(1743 17104)",
    fill: "#8296e8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_302-37",
    "data-name": "Ellipse 302",
    cx: 4.5,
    cy: 4.5,
    r: 4.5,
    transform: "translate(1759 17104)",
    fill: "#8296e8"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1675 -16999)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_301-38",
    "data-name": "Ellipse 301",
    cx: 4.5,
    cy: 4.5,
    r: 4.5,
    transform: "translate(1743 17104)",
    fill: "#8296e8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_302-38",
    "data-name": "Ellipse 302",
    cx: 4.5,
    cy: 4.5,
    r: 4.5,
    transform: "translate(1759 17104)",
    fill: "#8296e8"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1641 -16999)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_301-39",
    "data-name": "Ellipse 301",
    cx: 4.5,
    cy: 4.5,
    r: 4.5,
    transform: "translate(1743 17104)",
    fill: "#8296e8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_302-39",
    "data-name": "Ellipse 302",
    cx: 4.5,
    cy: 4.5,
    r: 4.5,
    transform: "translate(1759 17104)",
    fill: "#8296e8"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1607 -16999)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_301-40",
    "data-name": "Ellipse 301",
    cx: 4.5,
    cy: 4.5,
    r: 4.5,
    transform: "translate(1743 17104)",
    fill: "#8296e8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_302-40",
    "data-name": "Ellipse 302",
    cx: 4.5,
    cy: 4.5,
    r: 4.5,
    transform: "translate(1759 17104)",
    fill: "#8296e8"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1743 -16984)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_301-41",
    "data-name": "Ellipse 301",
    cx: 4.5,
    cy: 4.5,
    r: 4.5,
    transform: "translate(1743 17104)",
    fill: "#8296e8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_302-41",
    "data-name": "Ellipse 302",
    cx: 4.5,
    cy: 4.5,
    r: 4.5,
    transform: "translate(1759 17104)",
    fill: "#8296e8"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1709 -16984)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_301-42",
    "data-name": "Ellipse 301",
    cx: 4.5,
    cy: 4.5,
    r: 4.5,
    transform: "translate(1743 17104)",
    fill: "#8296e8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_302-42",
    "data-name": "Ellipse 302",
    cx: 4.5,
    cy: 4.5,
    r: 4.5,
    transform: "translate(1759 17104)",
    fill: "#8296e8"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1675 -16984)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_301-43",
    "data-name": "Ellipse 301",
    cx: 4.5,
    cy: 4.5,
    r: 4.5,
    transform: "translate(1743 17104)",
    fill: "#8296e8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_302-43",
    "data-name": "Ellipse 302",
    cx: 4.5,
    cy: 4.5,
    r: 4.5,
    transform: "translate(1759 17104)",
    fill: "#8296e8"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1641 -16984)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_301-44",
    "data-name": "Ellipse 301",
    cx: 4.5,
    cy: 4.5,
    r: 4.5,
    transform: "translate(1743 17104)",
    fill: "#8296e8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_302-44",
    "data-name": "Ellipse 302",
    cx: 4.5,
    cy: 4.5,
    r: 4.5,
    transform: "translate(1759 17104)",
    fill: "#8296e8"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1607 -16984)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_301-45",
    "data-name": "Ellipse 301",
    cx: 4.5,
    cy: 4.5,
    r: 4.5,
    transform: "translate(1743 17104)",
    fill: "#8296e8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_302-45",
    "data-name": "Ellipse 302",
    cx: 4.5,
    cy: 4.5,
    r: 4.5,
    transform: "translate(1759 17104)",
    fill: "#8296e8"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1743 -16969)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_301-46",
    "data-name": "Ellipse 301",
    cx: 4.5,
    cy: 4.5,
    r: 4.5,
    transform: "translate(1743 17104)",
    fill: "#8296e8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_302-46",
    "data-name": "Ellipse 302",
    cx: 4.5,
    cy: 4.5,
    r: 4.5,
    transform: "translate(1759 17104)",
    fill: "#8296e8"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1709 -16969)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_301-47",
    "data-name": "Ellipse 301",
    cx: 4.5,
    cy: 4.5,
    r: 4.5,
    transform: "translate(1743 17104)",
    fill: "#8296e8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_302-47",
    "data-name": "Ellipse 302",
    cx: 4.5,
    cy: 4.5,
    r: 4.5,
    transform: "translate(1759 17104)",
    fill: "#8296e8"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1675 -16969)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_301-48",
    "data-name": "Ellipse 301",
    cx: 4.5,
    cy: 4.5,
    r: 4.5,
    transform: "translate(1743 17104)",
    fill: "#8296e8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_302-48",
    "data-name": "Ellipse 302",
    cx: 4.5,
    cy: 4.5,
    r: 4.5,
    transform: "translate(1759 17104)",
    fill: "#8296e8"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1641 -16969)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_301-49",
    "data-name": "Ellipse 301",
    cx: 4.5,
    cy: 4.5,
    r: 4.5,
    transform: "translate(1743 17104)",
    fill: "#8296e8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_302-49",
    "data-name": "Ellipse 302",
    cx: 4.5,
    cy: 4.5,
    r: 4.5,
    transform: "translate(1759 17104)",
    fill: "#8296e8"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1607 -16969)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_301-50",
    "data-name": "Ellipse 301",
    cx: 4.5,
    cy: 4.5,
    r: 4.5,
    transform: "translate(1743 17104)",
    fill: "#8296e8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_302-50",
    "data-name": "Ellipse 302",
    cx: 4.5,
    cy: 4.5,
    r: 4.5,
    transform: "translate(1759 17104)",
    fill: "#8296e8"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1743 -16954)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_301-51",
    "data-name": "Ellipse 301",
    cx: 4.5,
    cy: 4.5,
    r: 4.5,
    transform: "translate(1743 17104)",
    fill: "#8296e8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_302-51",
    "data-name": "Ellipse 302",
    cx: 4.5,
    cy: 4.5,
    r: 4.5,
    transform: "translate(1759 17104)",
    fill: "#8296e8"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1709 -16954)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_301-52",
    "data-name": "Ellipse 301",
    cx: 4.5,
    cy: 4.5,
    r: 4.5,
    transform: "translate(1743 17104)",
    fill: "#8296e8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_302-52",
    "data-name": "Ellipse 302",
    cx: 4.5,
    cy: 4.5,
    r: 4.5,
    transform: "translate(1759 17104)",
    fill: "#8296e8"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1675 -16954)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_301-53",
    "data-name": "Ellipse 301",
    cx: 4.5,
    cy: 4.5,
    r: 4.5,
    transform: "translate(1743 17104)",
    fill: "#8296e8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_302-53",
    "data-name": "Ellipse 302",
    cx: 4.5,
    cy: 4.5,
    r: 4.5,
    transform: "translate(1759 17104)",
    fill: "#8296e8"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1641 -16954)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_301-54",
    "data-name": "Ellipse 301",
    cx: 4.5,
    cy: 4.5,
    r: 4.5,
    transform: "translate(1743 17104)",
    fill: "#8296e8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_302-54",
    "data-name": "Ellipse 302",
    cx: 4.5,
    cy: 4.5,
    r: 4.5,
    transform: "translate(1759 17104)",
    fill: "#8296e8"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1607 -16954)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_301-55",
    "data-name": "Ellipse 301",
    cx: 4.5,
    cy: 4.5,
    r: 4.5,
    transform: "translate(1743 17104)",
    fill: "#8296e8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_302-55",
    "data-name": "Ellipse 302",
    cx: 4.5,
    cy: 4.5,
    r: 4.5,
    transform: "translate(1759 17104)",
    fill: "#8296e8"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1743 -16939)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_301-56",
    "data-name": "Ellipse 301",
    cx: 4.5,
    cy: 4.5,
    r: 4.5,
    transform: "translate(1743 17104)",
    fill: "#8296e8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_302-56",
    "data-name": "Ellipse 302",
    cx: 4.5,
    cy: 4.5,
    r: 4.5,
    transform: "translate(1759 17104)",
    fill: "#8296e8"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1709 -16939)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_301-57",
    "data-name": "Ellipse 301",
    cx: 4.5,
    cy: 4.5,
    r: 4.5,
    transform: "translate(1743 17104)",
    fill: "#8296e8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_302-57",
    "data-name": "Ellipse 302",
    cx: 4.5,
    cy: 4.5,
    r: 4.5,
    transform: "translate(1759 17104)",
    fill: "#8296e8"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1675 -16939)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_301-58",
    "data-name": "Ellipse 301",
    cx: 4.5,
    cy: 4.5,
    r: 4.5,
    transform: "translate(1743 17104)",
    fill: "#8296e8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_302-58",
    "data-name": "Ellipse 302",
    cx: 4.5,
    cy: 4.5,
    r: 4.5,
    transform: "translate(1759 17104)",
    fill: "#8296e8"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1641 -16939)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_301-59",
    "data-name": "Ellipse 301",
    cx: 4.5,
    cy: 4.5,
    r: 4.5,
    transform: "translate(1743 17104)",
    fill: "#8296e8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_302-59",
    "data-name": "Ellipse 302",
    cx: 4.5,
    cy: 4.5,
    r: 4.5,
    transform: "translate(1759 17104)",
    fill: "#8296e8"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1607 -16939)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_301-60",
    "data-name": "Ellipse 301",
    cx: 4.5,
    cy: 4.5,
    r: 4.5,
    transform: "translate(1743 17104)",
    fill: "#8296e8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_302-60",
    "data-name": "Ellipse 302",
    cx: 4.5,
    cy: 4.5,
    r: 4.5,
    transform: "translate(1759 17104)",
    fill: "#8296e8"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDots);
export default __webpack_public_path__ + "static/media/dots.1518265fac6da508154906ce0f18224b.svg";
export { ForwardRef as ReactComponent };